import React from 'react';
import config from '../../../data/SiteConfig';
import './Footer.css';
import fa from '../../assets/images/facebook.svg';
import yt from '../../assets/images/youtube.svg';

function Footer() {
  const { copyright } = config;
  if (!copyright) {
    return null;
  }
  return (
    <footer className='footer'>
      <div className='wrapper'>
        <div className='copyright'>
          <div>
            &copy; {new Date().getFullYear()} {copyright}
          </div>
        </div>
        <div className='block social-follow'>
          <div className='subtitle'>تابعنا علي</div>
          <ul className='unstyled list-inline'>
            <li className='facebook'>
              <a
                rel='noreferrer'
                target='_blank'
                href='https://www.facebook.com/mo'>
                <img src={fa} alt='facebook' />
              </a>
            </li>
            <li className='youtube'>
              <a
                target='_blank'
                rel='noreferrer'
                href='https://www.youtube.com/channel/mo'>
                <img src={yt} alt='youtube' />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
